function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTabletRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 27a1 1 0 01-1 1H7a1 1 0 01-1-1V5c0-.542.458-1 1-1h18c.542 0 1 .458 1 1v22zM25 2H7C5.35 2 4 3.35 4 5v22a3 3 0 003 3h18a3 3 0 003-3V5c0-1.65-1.35-3-3-3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 23h12V8H10v15zm-2 2h16V6H8v19z",
    fill: props.color
  }));
}

export default SvgIconTabletRexOutline;